module.exports = __webpack_public_path__ + "static/media/Supplies.3bd0a42d.png";